import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

import styles from "../../../Profile.module.css";

class InstituteCode extends React.Component {
  constructor(props) {
    super(props);
    const { t } = this.props;
    this.state = {
      edit: false,
      institueCode: t("profile.typeIstituteCode"),
      codes: [],
      text: "",
      loadingCodes: false,
      error: null,
    };

    this.changeText = this.changeText.bind(this);
    this.fetchInstituteCodes = this.fetchInstituteCodes.bind(this);
  }

  componentDidMount() {
    this.fetchInstituteCodes();
  }

  async fetchInstituteCodes() {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const token = userData?.token;
    
    const URL = `${process.env.REACT_APP_API_BASE_URL}api/v1/profile/dept_subs/${this.props.profileId}/`;

    this.setState({ loadingCodes: true, error: null });

    try { 
      const headers = token ? { Authorization: `Token ${token}` } : {};

      if (token) {
        headers["Authorization"] = `Token ${token}`;
      }

      const res = await fetch(URL, {
        method: "POST",
        headers,
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`API error ${res.status}: ${text}`);
      }

      const data = await res.json();

      let codes = [];
      if (data && Array.isArray(data.data)) {
        codes = data.data
          .map((item) => {
            if (!item) return null;
            return typeof item === "string" ? item : item.code || item.name || null;
          })
          .filter(Boolean);
      }

      this.setState({ codes, loadingCodes: false });
    } catch (error) {
      console.error("Failed to fetch institute codes:", error);
      this.setState({ error: error.message || String(error), loadingCodes: false, codes: [] });
    }
  }

  changeEdit(edit) {
    this.setState({ edit: edit });
  }

  changeText(text) {
    this.setState({ text: text });
  }

  render() {
    const { t } = this.props;
    const { codes, loadingCodes } = this.state;

    return (
      <div
        className={styles.desc}
        style={{
          boxShadow: "0px 0px 20px #5555551a",
          padding: 10,
          borderRadius: 10,
          width: "100%",
          marginBottom: "25px",
        }}
      >
        <div
          style={{
            display: "flex",
            padding: 5,
            justifyContent: "space-between",
          }}
        >
          <p
            style={{
              fontWeight: 600,
              fontSize: 15,
              margin: 0,
              color: "var(--secondary-main)",
              lineHeight: "24px",
            }}
          >
            {t("profile.instituteCode")}: {" "}
            <span style={{ color: "#000", fontWeight: 500 }}>
              {loadingCodes ? (
                  ""
                ) : codes.length > 0 ? (
                  codes.join(", ")
                ) : (
                  t("profile.noCodes") || "—"
              )}
            </span>
          </p>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    deptCodeView: state?.profile?.deptCodeView || "",
  };
}
export default withTranslation()(connect(mapStateToProps, null)(InstituteCode));
